import { Component, Inject, OnInit } from '@angular/core';
import { SickLeaveListService } from './services/sick-leave-list.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ConfigService } from './services/config.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  public sessionFlag: boolean;
  public sessionKey: string;
  public token: string;
  public date;
  public userId;
  todate
  minDate
  config: Partial<BsDatepickerConfig>;

  constructor(
    public translate: TranslateService,
    public sickLeaveListService: SickLeaveListService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public configService: ConfigService) {

    this.minDate = new Date('12/13/2018')
    this.config = Object.assign(
      {},
      {
        containerClass: 'theme-red',
        showWeekNumbers: false,
        dateInputFormat: 'DD-MM-YYYY'
      }
    );
  }

  ngOnInit() {

    this.sessionFlag = false;
    this.userId = null;
    this.translate.setDefaultLang('en');
    this.translate.use('en');

    if (window.location.origin.indexOf('localhost') !== -1) {
      this.sessionKey = '';
      this.sessionFlag = true;
      this.token = '';
      //sessionStorage.setItem('sessionKey', this.token);
      this.sickLeaveListService.getInfo();
    } else {
      /*
      this.sessionFlag = false;
      this.token = this.sickLeaveListService.extractTokenFromUrl();
      if (this.token) {
        sessionStorage.setItem('sessionKey', this.token);
        this.sessionFlag = true;
        this.getInfo();
      } else if (!this.sickLeaveListService.checkForToken()) {
        this.sessionFlag = false;
        this.sickLeaveListService.redirectToSAB();
      }
      */
      this.login()
    }
  }

  public async login(): Promise<void>{
    if(this.sickLeaveListService.checkForToken()){
      sessionStorage.setItem('sessionKey', sessionStorage.getItem('sessionKey'));
      this.sessionFlag = true;
      this.sickLeaveListService.getInfo();
    }else{
      this.sessionFlag = false;
      if (!sessionStorage.getItem('code_challenge')) {
        this.sickLeaveListService.redirectToSAB();
      }
      else{
        this.sickLeaveListService.callPingLoginService();
      }
    }
  }

  

  // Logout(){
  //   sessionStorage.removeItem('sessionKey');
  //   sessionStorage.clear();
  //   this.redirectToSAB();
  // }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts